<div class="flex items-center py-4" [class]="className">
    <img [src]="src" [alt]="alt" class="w-10 m-8" />
    <div class="mr-8">
        <ng-content></ng-content>
    </div>
</div>
